import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SGKB992AService, Sgkb992aRequest, Sgkb992aResponse, } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb992aService {
  /** 社員情報検索結果のSubject */
  private _departmentInfoSearchResult$: Subject<Sgkb992aResponse> = new Subject<Sgkb992aResponse>();

  /**
   * 社員情報検索結果のobservable提供
   * @readonly
   * @memberof UsedSgkb992aService
   */
  get departmentInfoSearchChanges(): Observable<Sgkb992aResponse> {
    return this._departmentInfoSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKB992AService} SGKB992AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @memberof UsedSgkb992aService
   */
  constructor(
    private sGKB992AService: SGKB992AService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   *社員情報検索API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Sgkb992aResponse>}
   * @memberof UsedSgkb992aService
   */
  searchContractor(value: Sgkb992aRequest): Observable<Sgkb992aResponse> {
    // 年月日項目のフォーマット
    this.apiCommonService.convertElementInObject(value, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    // 検索条件を保存
    return this.sGKB992AService.SGKB992APost(<Sgkb992aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._departmentInfoSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKB992A);
          return throwError(err.message);
        })
      );
  }
}
